module.exports = __webpack_public_path__ + "img/1 (86).7ebcd574.png";